class PersonsAgiReportModel {
    constructor({
                    pid = '',
                    period = '',
                    agUnderlag = '',
                    framraknadAG = '',
                    tax = '',
                    bil = '',
                    uid = '',
                    andelStyrelsearvode = '',
                } = {}) {
        this.pid = pid;
        this.period = period;
        this.agUnderlag = agUnderlag;
        this.framraknadAG = framraknadAG;
        this.tax = tax;
        this.bil = bil;
        this.uid = uid;
        this.andelStyrelsearvode = andelStyrelsearvode;
    }

    static getAttributes(filter = null, validationSchema = null) {

        const attributes = {
            pid :{
                'label': 'Personnummer',
                'sortable': true,
                'sortField': 'pid',
                'value': (item) => item.pid || "",
            },
            period :{
                'label': 'Period',
                'sortable': true,
                'sortField': 'period',
                'value': (item) => item.period || "",
            },
            agUnderlag :{
                'label': 'Underlag för AG',
                'sortable': true,
                'sortField': 'agUnderlag',
                'value': (item) => item.agUnderlag || "",
                'thClass': 'text-end align-middle',
                'tdClass': () => 'text-end align-middle',
            },
            framraknadAG :{
                'label': 'Framräknad AG',
                'sortable': true,
                'sortField': 'framraknadAG',
                'value': (item) => item.framraknadAG || "",
                'thClass': 'text-end align-middle',
                'tdClass': () => 'text-end align-middle',
            },
            tax :{
                'label': 'Skatt',
                'sortable': true,
                'sortField': 'tax',
                'value': (item) => item.tax || "",
                'thClass': 'text-end align-middle',
                'tdClass': () => 'text-end align-middle',
            },
            bil :{
                'label': 'Bilersättning',
                'sortable': true,
                'sortField': 'bil',
                'value': (item) => item.bil || "",
                'type': 'checkbox',
            },
            uid :{
                'label': 'UID',
                'sortable': true,
                'sortField': 'uid',
                'value': (item) => item.uid || "",
            },
            andelStyrelsearvode :{
                'label': 'Andel styrelsearvode',
                'sortable': true,
                'sortField': 'andelStyrelsearvode',
                'value': (item) => item.andelStyrelsearvode || "",
                'thClass': 'text-end align-middle',
                'tdClass': () => 'text-end align-middle',
            },
        }

        return attributes;
    }
}

export default PersonsAgiReportModel;